/**
 * Firebase Initialization for Web
 */

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { firebaseConfig } from './firebase';

// Initialize Firebase only if not already initialized
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
  console.log('[Firebase] Firebase app initialized');
} else {
  app = getApps()[0];
  console.log('[Firebase] Firebase app already initialized');
}

// Initialize Auth with session persistence
const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence);

// Initialize Database
const database = getDatabase(app);

// Initialize Firestore
const firestore = getFirestore(app);

// Initialize Functions with explicit region for v2 functions
const functions = getFunctions(app, 'us-central1');

// Connect to emulators in development for NON-auth flows (photos, analytics, etc.)
// Auth-specific calls (e.g. mapAzureADUser) use their own Functions instances and
// are wired directly to production in WebCloudFunctionsService/SecureConfigService.
const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const useEmulator =
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' &&
  (process.env.NODE_ENV === 'development' || isLocalhost);

if (useEmulator) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5100);
    console.log('[Firebase] ✅ Connected to Functions emulator on localhost:5100 for general web calls');
  } catch (error: any) {
    // Already connected or emulator not running - this is OK
    if (error?.message?.includes('already been called') || error?.message?.includes('already initialized')) {
      console.log('[Firebase] Functions emulator already connected');
    } else {
      console.warn('[Firebase] ⚠️  Could not connect to Functions emulator, using production:', error?.message || error);
    }
  }
} else {
  console.log('[Firebase] Using production Firebase Functions for general web calls');
}

export default app;
export { auth, database, firestore, functions, firebaseConfig };

